import { render, staticRenderFns } from "./AddUserMessage.vue?vue&type=template&id=aa628ffe&scoped=true&"
import script from "./AddUserMessage.vue?vue&type=script&lang=ts&"
export * from "./AddUserMessage.vue?vue&type=script&lang=ts&"
import style0 from "./AddUserMessage.vue?vue&type=style&index=0&id=aa628ffe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.4.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa628ffe",
  null
  
)

component.options.__file = "AddUserMessage.vue"
export default component.exports